export default {"src":"/_next/static/media/pencil.9957eab9.svg","height":7,"width":7,"blurWidth":0,"blurHeight":0};